import { Center } from "@chakra-ui/layout"
import React from "react"
import { Control, useController } from "react-hook-form"
import styled from "styled-components"

import Checkbox from "~/components/atoms/Checkbox"
import { FormContainer } from "~/components/molecules/FormContainer"
import { Color, LineHeight, TextSize } from "~/consts/style-mixins"
import { useMobileMedia } from "~/hooks/useMobileMedia"

import { Section } from "../components/Section"
import { LABELS, VALIDATE_MAP } from "../constants"
import { HackedPostAuthRegisterBody } from "../types"

type Props = {
  control: Control<HackedPostAuthRegisterBody>
}

export const ApplicationCategory: React.VFC<Props> = ({ control }) => {
  const isMobile = useMobileMedia()

  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({
    control,
    name: "application_category_ids",
  })

  return (
    <Section title={LABELS.applicationCategoryIds}>
      <FormContainer errorMessage={error?.message}>
        <Checkbox
          type="Medium"
          items={[
            { text: "就職活動", value: "3" },
            { text: "長期インターン", value: "1" },
          ]}
          columnNumber={isMobile ? 1 : 2}
          values={value}
          onClick={onChange}
          isError={!!error?.message}
        />
      </FormContainer>
    </Section>
  )
}
